import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Search, Package, Layers, Bell, Home } from 'lucide-react';

const MobileNav = React.memo(() => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/dashboard', icon: Search, label: 'Search', focusSearch: true },
    { path: '/cabinet', icon: Package, label: 'Cabinet' },
    { path: '/stacks', icon: Layers, label: 'Stacks' },
    { path: '/reminders', icon: Bell, label: 'Reminders' },
  ];

  const isActive = (item) => {
    // Home is active only on landing page
    if (item.label === 'Home') {
      return location.pathname === '/';
    }
    // Search button is active on dashboard
    if (item.label === 'Search') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(item.path);
  };

  const handleNavClick = (item) => {
    if (item.focusSearch) {
      // Navigate to dashboard and focus search input
      if (location.pathname === '/dashboard') {
        // Already on dashboard, just focus search
        const searchInput = document.querySelector('[data-testid="search-input"]');
        if (searchInput) searchInput.focus();
      } else {
        navigate('/dashboard');
        setTimeout(() => {
          const searchInput = document.querySelector('[data-testid="search-input"]');
          if (searchInput) searchInput.focus();
        }, 100);
      }
    } else {
      // Normal navigation
      navigate(item.path);
    }
  };

  return (
    <nav className="mobile-nav md:hidden" data-testid="mobile-nav">
      <div className="flex items-center justify-around">
        {navItems.map((item) => (
          <button
            key={item.label}
            onClick={() => handleNavClick(item)}
            className={`mobile-nav-item ${isActive(item) ? 'active' : ''}`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
});

export default MobileNav;
